import Vue from "vue";
// import isMobile from "ismobilejs/dist/isMobile.min.js";
Vue.config.productionTip = false;
// document.body.className = isMobile.any ? "app-mobile" : "app-web";
document.body.className = "app-web";
export default {
    mount(App) {
        new Vue({
            render: h => h(App)
        }).$mount("#app");
    }
};
